import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public message: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public noAccount: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public noAccountMessage: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  displayLoader(value: boolean, message: string = 'Loading...') {
    this.message.next(message);
    this.status.next(value);
  }

  displayNoAccount(value: boolean, message: string = 'No account associated with this user.') {
    this.noAccountMessage.next(message);
    this.noAccount.next(value);
  }

  show(): void {
    this.isLoadingSubject.next(true);
  }
  hide(): void {
    this.isLoadingSubject.next(false);
  }

}
